// src/utils/apiUtils.js

/**
 * エラーレスポンスを処理し、ユーザーにフレンドリーなメッセージを返す
 * @param {Object} error - エラーオブジェクト
 * @returns {String} ユーザーに表示するエラーメッセージ
 */
export const handleApiError = (error) => {
  if (error.response) {
    // サーバーからのレスポンスが返ってきた場合
    return `Error: ${error.response.status} - ${error.response.data?.result?.error_message}`;
  } else if (error.request) {
    // リクエストが送信されたが応答がない場合
    return "Error: No response from server. Please try again later.";
  } else {
    // その他のエラー
    return `Error: ${error.message}`;
  }
};
